const PAGE_SIZE = 40
const VIEWS = [
  { value: 'all', label: 'All Runs' },
  { value: 'active', label: 'Active' },
  { value: 'needs_attention', label: 'Needs Attention' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' }
]

function positiveId(value) {
  if (!/^[1-9][0-9]*$/.test(String(value))) return null
  const id = Number(value)
  return Number.isSafeInteger(id) ? id : null
}

function listState(query = {}) {
  const state = {
    view: 'all',
    page: '1',
    search: '',
    stage: '',
    manager_id: '',
    provider: '',
    attention_category: '',
    date_from: '',
    date_to: ''
  }
  Object.keys(state).forEach((key) => {
    if (typeof query[key] === 'string') state[key] = query[key]
  })
  return state
}

function dateBoundary(value, nextDay = false) {
  if (!value) return undefined
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) throw new Error('Choose a valid started period.')
  const [year, month, day] = value.split('-').map(Number)
  const date = new Date(year, month - 1, day)
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) throw new Error('Choose a valid started period.')
  if (nextDay) date.setDate(date.getDate() + 1)
  return date.toISOString()
}

function listParams(state, summary = false) {
  if (!positiveId(state.page)) throw new Error('Page must be a positive integer.')
  if (!VIEWS.some((view) => view.value === state.view)) throw new Error('Unknown run selection.')
  if (state.manager_id && !positiveId(state.manager_id)) throw new Error('Invalid manager at start.')
  const search = (state.search || '').trim()
  if (search.length > 255) throw new Error('Search must be at most 255 characters.')
  const params = {
    search,
    stage: state.stage,
    manager_id: state.manager_id,
    provider: state.provider,
    attention_category: state.attention_category,
    started_from: dateBoundary(state.date_from),
    started_to: dateBoundary(state.date_to, true)
  }
  if (params.started_from && params.started_to && params.started_from >= params.started_to) throw new Error('The end date must be on or after the start date.')
  if (!summary) Object.assign(params, { view: state.view, page: Number(state.page), page_size: PAGE_SIZE })
  return Object.keys(params).reduce((result, key) => {
    if (params[key] !== '' && params[key] !== undefined && params[key] !== null) result[key] = params[key]
    return result
  }, {})
}

function errorMessage(error) {
  const response = error && error.response
  const data = response && response.data
  if (response && response.status === 403) return 'You do not have access to this record.'
  if (response && response.status === 404) return 'The record or page was not found or is no longer available.'
  return (
    (data && (data.details || data.detail || data.message)) ||
    (error && error.message) ||
    'Unable to load data. Please try again.'
  )
}

function statusTone(status) {
  const code = status && status.code
  if (['active', 'completed', 'sent', 'delivered', 'read', 'accepted', 'enabled', 'ready', 'processed'].includes(code)) return 'green'
  if (['planned', 'sending', 'in_progress', 'queued', 'processing', 'pending'].includes(code)) return 'blue'
  if (['paused', 'skipped', 'needs_attention', 'outcome_unknown', 'unmatched'].includes(code)) return 'amber'
  if (['failed', 'cancelled', 'permanent_fail'].includes(code)) return 'red'
  return 'neutral'
}

function display(value) {
  if (value === null || value === undefined || value === '') return '—'
  if (typeof value === 'object') return value.name || value.label || value.code || JSON.stringify(value, null, 2)
  return String(value)
}

function dateTime(value) {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })
}

function payloadText(payload) {
  if (!payload || payload.availability !== 'stored') return null
  if (payload.format === 'json') return JSON.stringify(payload.data, null, 2)
  return String(payload.data === null ? '' : payload.data)
}

function delayTimeDisabled(value, now = Date.now(), maxDays = 14) {
  const time = new Date(value || '').getTime()
  return !Number.isFinite(time) || time <= now || time > now + (maxDays * 86400000)
}

function delayDateDisabled(value, now = Date.now(), maxDays = 14) {
  const day = new Date(value).setHours(0, 0, 0, 0)
  const firstDay = new Date(now).setHours(0, 0, 0, 0)
  const lastDay = new Date(now + (maxDays * 86400000)).setHours(0, 0, 0, 0)
  return !Number.isFinite(day) || day < firstDay || day > lastDay
}

function delayErrors(form, now = Date.now(), maxDays = 14) {
  const errors = {}
  if (!form.until) errors.until = 'Required field'
  else if (delayTimeDisabled(form.until, now, maxDays)) errors.until = `Choose a future time within ${maxDays} days.`
  const reason = String(form.reason || '').trim()
  if (!reason || reason.length > 255) errors.reason = 'Required field'
  return errors
}

module.exports = {
  PAGE_SIZE,
  VIEWS,
  positiveId,
  listState,
  listParams,
  dateBoundary,
  errorMessage,
  statusTone,
  display,
  dateTime,
  payloadText,
  delayTimeDisabled,
  delayDateDisabled,
  delayErrors
}
